import React, { useEffect, useRef, useState } from "react";
import { Fragment } from "react";
import { useAxiosClient } from "../../hooks/useAxiosClient";
import efpaConfig from "../../utils/efpaConfig";
import getLoginType from "../../utils/loginConfig";
import EfpaBtn from "../EfpaBtn";
import EfpaForm from "../EfpaForm";
import EfpaInput from "../EfpaInput";
import EfpaLabel from "../EfpaLabel";
import EfpaLink from "../EfpaLink";
import Message from "../Message";
import HTMLReactParser from 'html-react-parser';
import useCaptchaValidation from "../../hooks/useCaptchaValidation";
import ReCAPTCHA from "react-google-recaptcha";
// import PropTypes from 'prop-types';

const requiredFields = [
  "first_name",
  "identity_document",
  "last_name",
  "professional_email",
  "password",
  "confirm_password",
];

const validateLcci = () => {
  const logintype = getLoginType();
  return logintype.name === "lcci";
};

const RegisterForm = (props) => {
  const { captchaRef, captchaError, validateCaptcha, resetCaptchaError } = useCaptchaValidation();
  const [errorData, setErroData] = useState();
  const { current: isLcci } = useRef(validateLcci());
  const [successMSG, setSuccessMSG] = useState();
  const [formData, setFormData] = useState({});
  const [initialData, setInitialData] = useState({});
  const [, triggerRequest] = useAxiosClient({}, { manual: true });
  const [{ data: rootToken }] = useAxiosClient({
    baseURL: efpaConfig.PROXY_URL,
    url: "/token/",
    method: "post",
  });
  const [{ data: showForm = {} }, getShowForm] = useAxiosClient(
    {
      url: "/exams/are-open-exams/",
      params: isLcci
        ? {
            lcci: 1,
          }
        : null,
    },
    { manual: true }
  );

  useEffect(() => {
    if (rootToken && rootToken.access)
      getShowForm({
        headers: {
          Authorization: `Bearer ${rootToken.access}`,
        },
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootToken]);

  useEffect(() => {
    setInitialData(() => {
      const queryParams = new URLSearchParams(
        (window && window.location.search) || ""
      );
      return {
        identity_document: queryParams.get("identity_document"),
        email: queryParams.get("email"),
        nonew: queryParams.get("nonew"),
      };
    });
  }, []);

  const onSubmit = async (isValid) => {
    resetCaptchaError();

    if (!validateCaptcha()) {
      return;
    }
    if (!isValid) return setErroData({ code: "val" });
    if (formData.password !== formData.confirm_password)
      return setErroData({ code: "pass" });
    const rootToken = await triggerRequest({
      baseURL: efpaConfig.PROXY_URL,
      url: "/token/",
      method: "POST",
    }).then(({ data }) => data.access);

    if (!rootToken) return;

    let data = formData ? { ...formData } : {};
    if (isLcci) data["lcci"] = 1;

    triggerRequest({
      url: "/persons/exams/new-register/",
      method: "POST",
      data,
      headers: {
        Authorization: `Bearer ${rootToken}`,
      },
    })
      .then(({ data, status }) => {
        if (data.color === "green") setSuccessMSG(data.message);
        setErroData({ code: status, message: data.message });
      })
      .catch(({ response: { data, status } }) =>
        setErroData({
          code: status,
          message:
            data.message ||
            "Inténtelo más tarde o póngase en contacto con EFPA España",
        })
      );
  };

  const onChange = ({ target: { value, name } }) =>
    setFormData((prev) => ({ ...prev, [name]: value }));

  const renderErrorMsg = () => {
    switch (errorData.code) {
      case "val":
        return (
          <Message type="error">
            Debe completar todos los campos obligatorios (*).
          </Message>
        );
      case "pass":
        return (
          <Message type="error">
            Las contraseñas introducidas no coinciden.
          </Message>
        );

      default:
        return <div className="Message Message-error EfpaLabel-font" dangerouslySetInnerHTML={{__html: errorData.message}}></div>;
    }
  };

  const renderForm = () => (
    <Fragment>
      {errorData && <div className="p-2">{renderErrorMsg()} </div>}
      <EfpaForm
        basic
        className="d-flex"
        requiredInputs={requiredFields}
        onSubmit={onSubmit}
      >
        <div className="Login-cardContent">
          <EfpaInput
            label="Nombre"
            name="first_name"
            labelPosition="top"
            onChange={onChange}
            required
          />
          <EfpaInput
            label="Primer apellido"
            name="last_name"
            labelPosition="top"
            onChange={onChange}
            required
          />
          <EfpaInput
            label="Segundo apellido"
            name="second_last_name"
            labelPosition="top"
            onChange={onChange}
          />
          <EfpaInput
            label="DNI/NIE"
            name="identity_document"
            initialValue={initialData.identity_document}
            disabled={!!initialData.identity_document}
            saveInitialValue
            labelPosition="top"
            onChange={onChange}
            required
          />
        </div>
        <div className="Login-cardContent">
          <EfpaInput
            label="Email profesional"
            name="professional_email"
            labelPosition="top"
            initialValue={initialData.email}
            disabled={!!initialData.email}
            saveInitialValue
            onChange={onChange}
            required
          />
          <EfpaInput
            label="Contraseña"
            name="password"
            labelPosition="top"
            onChange={onChange}
            required
            type="password"
          />
          <EfpaInput
            label="Repita la contraseña"
            name="confirm_password"
            labelPosition="top"
            onChange={onChange}
            required
            type="password"
          />
          <EfpaBtn className="mt-2">Aceptar</EfpaBtn>
          <EfpaLabel className="EfpaLink-font mt-2">
            Al registrarse acepta nuestra{" "}
            <EfpaLink to={efpaConfig.PRIVACY_POLICIES_URL} mode="outsideLink">
              política de privacidad
            </EfpaLink>
          </EfpaLabel>
        </div>
      </EfpaForm>
      <ReCAPTCHA
        sitekey={process.env.GATSBY_CAPTCHA_KEY}
        ref={captchaRef}
        className={"center mt-2"}
      />
      {captchaError && (
        <span className="center" style={{ color: "red" }}>Por favor, complete el captcha</span>
      )}
    </Fragment>
  );

  if (initialData?.nonew === "1" || showForm.open_exams === false) return null;

  return (
    <div className="Login-card RegisterForm">
      <h2 className="efpa-h2 Login-title">
        Nuevo registro{" "}
        <span style={{ fontSize: "16px" }}>
          (para su primera inscripción on-line)
        </span>
      </h2>
      {successMSG ? (
        <Message type="success" className="mx-2">
          {successMSG}
        </Message>
      ) : (
        renderForm()
      )}
    </div>
  );
};

RegisterForm.propTypes = {};

export default RegisterForm;
